import React from 'react';
import { IDetailsTab } from './interfaces';
import { Tab } from '../../Tab';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@mui/icons-material/Info';

export const DetailsTab: React.FC<IDetailsTab> = ({
  label,
  ...other
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Tab label={label || t('tabs.details')} icon={<InfoIcon />} {...other} />
  );
};
